import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import { title } from "../../Config/Config";

const BgSvg = () => {
    const [offsetdata, setOffsetdata] = useState<any>(null);
    const [bgColors, setBgColors] = useState<{ [key: string]: string }>({});
    const [innerColors, setInnerColors] = useState<{ [key: string]: string }>({});
    const [strokeColors, setStrokeColors] = useState<{ [key: string]: string }>({});
    const [opacities, setOpacities] = useState<{ [key: string]: number }>({});
    const [open, setOpen] = useState(false);

    const svgStoreArry = [
        {
            id: "1",
            code: (bgColor: string, innerColor: string, strokeColor: string, opacity: number) => (
                <svg className="w-full h-full" viewBox="0 0 400 400" style={{ backgroundColor: bgColor, opacity }}>
                    <defs>
                        <pattern id="pattern0" width="100" height="100" patternUnits="userSpaceOnUse">
                            <circle cx="25" cy="25" r="20" stroke={strokeColor} strokeWidth="6" fill="none"></circle>
                            <circle cx="22" cy="20" r="10" fill={innerColor}></circle>
                            <circle cx="25" cy="75" r="20" stroke={strokeColor} strokeWidth="6" fill="none"></circle>
                            <circle cx="22" cy="78" r="10" fill={innerColor}></circle>
                            <circle cx="75" cy="25" r="20" stroke={strokeColor} strokeWidth="6" fill="none"></circle>
                            <circle cx="80" cy="26" r="10" fill={innerColor}></circle>
                            <circle cx="75" cy="75" r="20" stroke={strokeColor} strokeWidth="6" fill="none"></circle>
                            <circle cx="80" cy="78" r="10" fill={innerColor}></circle>
                        </pattern>
                    </defs>
                    <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern0)"></rect>
                </svg>
            ),
        },
    ];

    const handleOpen = (item: any) => {
        setOffsetdata(item);
        setBgColors((prev) => ({ ...prev, [item.id]: prev[item.id] || "#ffffff" }));
        setInnerColors((prev) => ({ ...prev, [item.id]: prev[item.id] || "#7678ED" }));
        setStrokeColors((prev) => ({ ...prev, [item.id]: prev[item.id] || "#3D348B" }));
        setOpacities((prev) => ({ ...prev, [item.id]: prev[item.id] || 1 }));
        setOpen(true);
    };

    return (
        <>

        
            <div className="__svg-bg">
                <div className="__svg-bg-head">
                    <h1>Customize Your Backgrounds SVG Patterns</h1>
                    <h2>Create unique and dynamic backgrounds with customizable SVG patterns using {title}, ensuring seamless integration into your designs</h2>
                </div>

                <div className="__container">
                    <div className="row">
                        {svgStoreArry.map((item, index) => (
                            <div className="col-md-3" key={index} onClick={() => handleOpen(item)}>
                                <div className="__codesvg">
                                    {item.code(bgColors[item.id] || "#ffffff", innerColors[item.id] || "#7678ED", strokeColors[item.id] || "#3D348B", opacities[item.id] || 1)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Modal open={open} onClose={() => setOpen(false)} center
                classNames={{
                    overlay: 'svg-modal-overly',
                    modal: 'svg-modal'
                }}>
                {offsetdata && (
                    <>
                        <div>
                            <label>Background Color: </label>
                            <input
                                type="color"
                                value={bgColors[offsetdata.id]}
                                onChange={(e) => setBgColors({ ...bgColors, [offsetdata.id]: e.target.value })}
                            />
                        </div>

                        <div>
                            <label>Inner SVG Color: </label>
                            <input
                                type="color"
                                value={innerColors[offsetdata.id]}
                                onChange={(e) => setInnerColors({ ...innerColors, [offsetdata.id]: e.target.value })}
                            />
                        </div>

                        <div>
                            <label>Inner SVG Stroke Colors: </label>
                            <input
                                type="color"
                                value={strokeColors[offsetdata.id]}
                                onChange={(e) => setStrokeColors({ ...strokeColors, [offsetdata.id]: e.target.value })}
                            />
                        </div>

                        <div>
                            <label>Opacity: </label>
                            <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.1"
                                value={opacities[offsetdata.id]}
                                onChange={(e) => setOpacities({ ...opacities, [offsetdata.id]: parseFloat(e.target.value) })}
                            />
                        </div>

                        <div className="preview">
                            {offsetdata.code(bgColors[offsetdata.id], innerColors[offsetdata.id], strokeColors[offsetdata.id], opacities[offsetdata.id])}
                        </div>
                    </>
                )}
            </Modal>
        </>
    );
};

export default BgSvg;
